import { render } from "./reviewDealer.vue?vue&type=template&id=cef254d0"
import script from "./reviewDealer.vue?vue&type=script&lang=js"
export * from "./reviewDealer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__